module.exports = __webpack_public_path__ + "static/media/fatbird.2e6f42f6.png";